<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SETTINGS_EXTERNAL_DASHBOARDS' },
  ]"
></breadcrumbs>

<page-header title="SETTINGS_EXTERNAL_DASHBOARDS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_EXTERNAL_DASHBOARDS_ENABLE"
        >{{ 'SETTINGS_EXTERNAL_DASHBOARDS_ENABLE' | translate }}</label
      >
      <div class="control">
        <chip
          [checked]="getField(['SETTINGS_EXTERNAL_DASHBOARDS_ENABLE'])"
          (onChange)="
            checkboxChange($event, 'SETTINGS_EXTERNAL_DASHBOARDS_ENABLE')
          "
          [value]="!getField(['SETTINGS_EXTERNAL_DASHBOARDS_ENABLE'])"
        >
          <span
            [translationEditableDirective]="
              getField(['SETTINGS_EXTERNAL_DASHBOARDS_ENABLE'])
                ? 'ENABLED'
                : 'DISABLED'
            "
          >
            {{
              (getField(['SETTINGS_EXTERNAL_DASHBOARDS_ENABLE'])
                ? 'ENABLED'
                : 'DISABLED'
              ) | translate
            }}
          </span>
        </chip>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_EXTERNAL_DASHBOARDS_ENABLE')"
      >
        {{ getError('SETTINGS_EXTERNAL_DASHBOARDS_ENABLE') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_EXTERNAL_DASHBOARDS_URL"
        >{{ 'SETTINGS_EXTERNAL_DASHBOARDS_URL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_EXTERNAL_DASHBOARDS_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_EXTERNAL_DASHBOARDS_URL'])"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_EXTERNAL_DASHBOARDS_URL'),
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_EXTERNAL_DASHBOARDS_URL')"
      >
        {{ getError('SETTINGS_EXTERNAL_DASHBOARDS_URL') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_EXTERNAL_REPORTS_URL"
        >{{ 'SETTINGS_EXTERNAL_REPORTS_URL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_EXTERNAL_REPORTS_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_EXTERNAL_REPORTS_URL'])"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_EXTERNAL_REPORTS_URL'),
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_EXTERNAL_REPORTS_URL')"
      >
        {{ getError('SETTINGS_EXTERNAL_REPORTS_URL') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_EXTERNAL_MOBILE_URL"
        >{{ 'SETTINGS_EXTERNAL_MOBILE_URL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_EXTERNAL_MOBILE_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_EXTERNAL_MOBILE_URL'])"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_EXTERNAL_MOBILE_URL'),
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_EXTERNAL_MOBILE_URL')"
      >
        {{ getError('SETTINGS_EXTERNAL_MOBILE_URL') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
